import { CHANGE_SIZE, BOX_ADD } from "../type";

const initialState = {
  boxes: [],
  focused: {},
};

export default function contractReducer(state = initialState, action) {
  switch (action.type) {
    case CHANGE_SIZE:
      return { width: 155 };
    case BOX_ADD:
      return { ...state, boxes: [...state.boxes, action.payload] };
    default:
      return state;
  }
}
